/**
 * @prettier
 */
import _classnames from 'classnames';

// TODO: Rename exported constant to classNames so it has same camelCased name as react attribute to set className
export const classNames = _classnames;
